var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 1.87482C23.6335 1.87482 25.3124 3.55384 25.3125 5.62482V24.3748C25.3125 26.4459 23.6336 28.1248 21.5625 28.1248H8.4375C6.36643 28.1248 4.6875 26.4459 4.6875 24.3748V5.62482C4.68761 3.55384 6.3665 1.87482 8.4375 1.87482H21.5625ZM10.9375 22.491C10.4199 22.491 10.0002 22.911 10 23.4285C10 23.9463 10.4197 24.366 10.9375 24.366H19.375C19.8928 24.366 20.3125 23.9463 20.3125 23.4285C20.3123 22.911 19.8926 22.491 19.375 22.491H10.9375ZM10.9375 18.741C10.4199 18.741 10.0002 19.161 10 19.6785C10 20.1963 10.4197 20.616 10.9375 20.616H19.375C19.8928 20.616 20.3125 20.1963 20.3125 19.6785C20.3123 19.161 19.8926 18.741 19.375 18.741H10.9375ZM15 11.9559C13.2973 11.9559 11.8479 13.0288 11.2939 14.5301C11.1707 14.8646 11.3141 15.2383 11.6299 15.4061C12.6354 15.9392 13.7836 16.241 15 16.241C16.2164 16.241 17.3646 15.9392 18.3701 15.4061C18.6859 15.2383 18.8293 14.8646 18.7061 14.5301C18.1521 13.0288 16.7027 11.9559 15 11.9559ZM15 6.24103C13.811 6.24105 12.8467 7.20113 12.8467 8.38458C12.8468 9.56792 13.8111 10.5271 15 10.5272C16.1889 10.5272 17.1532 9.56793 17.1533 8.38458C17.1533 7.20112 16.189 6.24103 15 6.24103Z",
    fill: "#010F55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2410_7091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4304 6.18796C23.4351 6.12593 23.4375 6.06325 23.4375 6.00001C23.4375 5.61897 23.3501 5.25835 23.1942 4.93712C22.8849 5.2307 22.5168 5.46289 22.1093 5.61416C22.1197 5.74141 22.125 5.87009 22.125 6.00001C22.125 6.27531 22.1013 6.54507 22.0557 6.80735C22.5541 6.68195 23.0179 6.46983 23.4304 6.18796Z",
    fill: "url(#paint0_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6586 6.88754C21.7185 6.60111 21.75 6.30424 21.75 6.00001C21.75 5.90792 21.7471 5.81649 21.7414 5.72583C21.5035 5.78251 21.2553 5.81251 21 5.81251C20.7447 5.81251 20.4965 5.78251 20.2586 5.72583C20.2529 5.81649 20.25 5.90792 20.25 6.00001C20.25 6.30424 20.2815 6.60111 20.3414 6.88754C20.5561 6.92045 20.7761 6.93751 21 6.93751C21.2239 6.93751 21.4439 6.92045 21.6586 6.88754Z",
    fill: "url(#paint1_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4431 7.27977C20.6257 7.30139 20.8115 7.31251 21 7.31251C21.1885 7.31251 21.3743 7.30139 21.5569 7.27977C21.4285 7.69368 21.2394 8.0809 21 8.43103C20.7606 8.0809 20.5715 7.69368 20.4431 7.27977Z",
    fill: "url(#paint2_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9443 6.80735C19.8987 6.54507 19.875 6.27531 19.875 6.00001C19.875 5.87009 19.8803 5.74141 19.8907 5.61416C19.4832 5.46289 19.1151 5.2307 18.8058 4.93712C18.6499 5.25835 18.5625 5.61897 18.5625 6.00001C18.5625 6.06325 18.5649 6.12593 18.5696 6.18796C18.9821 6.46983 19.4459 6.68195 19.9443 6.80735Z",
    fill: "url(#paint3_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.339 6.68815C23.0851 7.55264 22.3649 8.21766 21.4694 8.39236C21.686 8.0281 21.8546 7.63199 21.9666 7.21274C22.4566 7.11003 22.9184 6.9308 23.339 6.68815Z",
    fill: "url(#paint4_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.661 6.68815C19.0816 6.9308 19.5434 7.11003 20.0334 7.21274C20.1454 7.63199 20.314 8.0281 20.5306 8.39236C19.6351 8.21766 18.9149 7.55264 18.661 6.68815Z",
    fill: "url(#paint5_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4694 3.60767C22.0998 3.73064 22.6433 4.09658 22.9984 4.60403C22.7338 4.87124 22.4159 5.08566 22.0621 5.23007C21.9655 4.64574 21.7609 4.09786 21.4694 3.60767Z",
    fill: "url(#paint6_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3.569C21.3572 4.0914 21.6024 4.69637 21.7012 5.34939C21.4771 5.40692 21.2421 5.43751 21 5.43751C20.7579 5.43751 20.5229 5.40692 20.2988 5.34939C20.3976 4.69637 20.6428 4.0914 21 3.569Z",
    fill: "url(#paint7_linear_2410_7091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5306 3.60767C20.2391 4.09786 20.0345 4.64574 19.9379 5.23007C19.5841 5.08566 19.2662 4.87124 19.0016 4.60403C19.3567 4.09658 19.9002 3.73064 20.5306 3.60767Z",
    fill: "url(#paint8_linear_2410_7091)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2410_7091",
    x1: 16.7978,
    y1: 1.511,
    x2: 24.4129,
    y2: 7.04597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2410_7091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(18 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalPassport);
export default __webpack_public_path__ + "static/media/international-passport.d7af33b29092ebe4f7afca41589eabfe.svg";
export { ForwardRef as ReactComponent };